import { NgModule } from '@angular/core';
import {
	Activity,
	AlertCircle,
	AppWindowMac,
	Archive,
	ArrowDown,
	ArrowDownRight,
	ArrowDownUp,
	ArrowLeft,
	ArrowLeftRight,
	ArrowRight,
	ArrowRightLeft,
	ArrowUp,
	ArrowUpRight,
	BadgeDollarSign,
	BadgeEuro,
	Ban,
	Banknote,
	BarChart2,
	BarChart3,
	Bell,
	BellOff,
	BellRing,
	Bitcoin,
	Bolt,
	BookCheck,
	BookOpen,
	BookX,
	Bot,
	Boxes,
	Brain,
	BrickWall,
	Briefcase,
	BriefcaseBusiness,
	Bug,
	Building,
	Building2,
	Calculator,
	Calendar,
	Calendar1,
	CalendarClock,
	CalendarDays,
	CalendarOff,
	CalendarPlus,
	CalendarRange,
	Camera,
	Caravan,
	ChartSpline,
	Check,
	CheckCheck,
	CheckCircle,
	CheckSquare,
	ChevronDown,
	ChevronFirst,
	ChevronLast,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
	CircleAlert,
	CircleArrowRight,
	CircleCheck,
	CircleDashed,
	CircleDollarSign,
	CircleX,
	ClipboardCheck,
	ClipboardList,
	Clock,
	Clock3,
	ClockArrowUp,
	CloudDownload,
	CloudUpload,
	Code,
	Coins,
	Construction,
	ContactRound,
	Cookie,
	Copy,
	CreditCard,
	Cross,
	Delete,
	DollarSign,
	DoorOpen,
	Download,
	Drill,
	Droplets,
	Edit,
	Ellipsis,
	EllipsisVertical,
	ExternalLink,
	Eye,
	EyeOff,
	File,
	FileArchive,
	FileCheck,
	FileClock,
	FileDown,
	FileInput,
	FileJson,
	FilePlus,
	FileSignature,
	FileSpreadsheet,
	FileText,
	FileUp,
	FileX,
	Filter,
	Fingerprint,
	Flame,
	FlaskConical,
	FolderOpen,
	Gem,
	Ghost,
	Globe,
	GraduationCap,
	GripHorizontal,
	GripVertical,
	Handshake,
	Hash,
	Heart,
	HelpCircle,
	Home,
	Hourglass,
	House,
	IdCard,
	IdCardLanyard,
	Image,
	ImagePlus,
	Inbox,
	Info,
	Landmark,
	Layers,
	LayoutDashboard,
	LayoutGrid,
	LayoutList,
	LifeBuoy,
	LineChart,
	Link,
	Link2,
	List,
	ListChecks,
	ListCollapse,
	ListFilter,
	ListTree,
	Loader,
	LoaderCircle,
	Lock,
	LockKeyhole,
	LogIn,
	LogOut,
	LucideAngularModule,
	Mail,
	MapPin,
	Megaphone,
	Menu,
	MessageCircle,
	MessageSquare,
	MessageSquarePlus,
	MessageSquareText,
	Mic,
	Minus,
	Monitor,
	Moon,
	MoreHorizontal,
	MoreVertical,
	MoveLeft,
	MoveRight,
	Newspaper,
	Package,
	Palette,
	PanelLeftClose,
	PanelLeftOpen,
	Paperclip,
	Pause,
	Pencil,
	PencilRuler,
	PenLine,
	PenTool,
	Percent,
	Phone,
	PhoneCall,
	Pin,
	Play,
	PlayCircle,
	Plug,
	Plus,
	Printer,
	Receipt,
	ReceiptText,
	RefreshCw,
	Repeat,
	RotateCcw,
	Save,
	Scale,
	ScrollText,
	Search,
	Send,
	Server,
	Settings,
	Settings2,
	Shield,
	ShieldAlert,
	ShieldCheck,
	ShoppingCart,
	Siren,
	SlidersHorizontal,
	Smartphone,
	Sparkles,
	SquareDashedMousePointer,
	SquareMousePointer,
	SquarePlus,
	Squircle,
	Star,
	StarOff,
	Stethoscope,
	StickyNote,
	Sun,
	Syringe,
	Tag,
	Tags,
	Ticket,
	Tickets,
	Timer,
	TimerReset,
	ToolCase,
	Trash,
	Trash2,
	TrendingUp,
	TriangleAlert,
	Undo2,
	Unlock,
	Upload,
	User,
	UserCheck,
	UserCog,
	UserMinus,
	UserPen,
	UserPlus,
	UserRound,
	UserRoundCog,
	Users,
	UsersRound,
	UserX,
	Video,
	Wallet,
	Waves,
	Webcam,
	Wifi,
	X,
	XCircle,
	Zap,
} from 'lucide-angular';

@NgModule({
	imports: [
		LucideAngularModule.pick({
			Activity,
			AlertCircle,
			AppWindowMac,
			ArrowDown,
			ArrowDownUp,
			ArrowLeft,
			ArrowLeftRight,
			ArrowRight,
			ArrowRightLeft,
			ArrowUp,
			ArrowUpRight,
			ArrowDownRight,
			Archive,
			BadgeDollarSign,
			BadgeEuro,
			Ban,
			Banknote,
			BarChart2,
			BarChart3,
			Bell,
			BellOff,
			BellRing,
			Bitcoin,
			Bolt,
			BookCheck,
			BookX,
			BookOpen,
			Bot,
			Boxes,
			Brain,
			BrickWall,
			Briefcase,
			Bug,
			BriefcaseBusiness,
			Building,
			Building2,
			Calculator,
			Calendar,
			CalendarRange,
			Calendar1,
			CalendarClock,
			CalendarDays,
			ChartSpline,
			CalendarOff,
			CalendarPlus,
			Camera,
			Caravan,
			Check,
			CheckCheck,
			CheckCircle,
			CheckSquare,
			ChevronDown,
			ChevronFirst,
			ChevronLast,
			ChevronLeft,
			ChevronRight,
			ChevronUp,
			CircleAlert,
			CircleArrowRight,
			CircleCheck,
			CircleDashed,
			CircleDollarSign,
			CircleX,
			ClipboardCheck,
			ClipboardList,
			Clock,
			Clock3,
			ClockArrowUp,
			CloudDownload,
			CloudUpload,
			Code,
			Coins,
			Construction,
			ContactRound,
			Cookie,
			CreditCard,
			Copy,
			Cross,
			DollarSign,
			DoorOpen,
			Download,
			Droplets,
			Drill,
			Edit,
			Ellipsis,
			EllipsisVertical,
			ExternalLink,
			Eye,
			EyeOff,
			File,
			FileArchive,
			FileCheck,
			FileClock,
			FileDown,
			FileInput,
			FileJson,
			FilePlus,
			FileSignature,
			FileSpreadsheet,
			FileText,
			FileUp,
			FileX,
			Filter,
			Fingerprint,
			Flame,
			FlaskConical,
			FolderOpen,
			Gem,
			Ghost,
			Globe,
			GraduationCap,
			GripHorizontal,
			GripVertical,
			Handshake,
			Hash,
			Heart,
			HelpCircle,
			Home,
			Hourglass,
			House,
			IdCard,
			IdCardLanyard,
			Image,
			ImagePlus,
			Inbox,
			Info,
			Landmark,
			Layers,
			LayoutDashboard,
			LayoutGrid,
			LayoutList,
			LifeBuoy,
			LineChart,
			Link,
			Link2,
			List,
			ListChecks,
			ListCollapse,
			ListFilter,
			ListTree,
			Loader,
			LoaderCircle,
			Lock,
			LockKeyhole,
			Delete,
			LogIn,
			LogOut,
			Mail,
			MapPin,
			Megaphone,
			Menu,
			MessageCircle,
			MessageSquare,
			MessageSquarePlus,
			MessageSquareText,
			Mic,
			Minus,
			Monitor,
			Moon,
			MoreHorizontal,
			MoreVertical,
			MoveLeft,
			MoveRight,
			Newspaper,
			Package,
			Palette,
			PanelLeftClose,
			PanelLeftOpen,
			Paperclip,
			Pause,
			Pencil,
			PencilRuler,
			PenLine,
			PenTool,
			Percent,
			Phone,
			Pin,
			PhoneCall,
			Play,
			PlayCircle,
			Plug,
			Plus,
			Printer,
			Receipt,
			ReceiptText,
			RefreshCw,
			Repeat,
			RotateCcw,
			Save,
			Scale,
			ScrollText,
			Search,
			Send,
			Server,
			Settings,
			Settings2,
			Shield,
			ShieldAlert,
			ShieldCheck,
			ShoppingCart,
			Siren,
			SlidersHorizontal,
			Smartphone,
			Sparkles,
			StarOff,
			SquareDashedMousePointer,
			SquareMousePointer,
			SquarePlus,
			Squircle,
			Star,
			Stethoscope,
			StickyNote,
			Sun,
			Syringe,
			Tag,
			Tags,
			Ticket,
			Tickets,
			Timer,
			TimerReset,
			ToolCase,
			Trash,
			Trash2,
			TrendingUp,
			TriangleAlert,
			Undo2,
			Unlock,
			Upload,
			User,
			UserCheck,
			UserCog,
			UserMinus,
			UserPlus,
			UserPen,
			UserRound,
			UserRoundCog,
			Users,
			UsersRound,
			UserX,
			Video,
			Wallet,
			Waves,
			Webcam,
			Wifi,
			X,
			XCircle,
			Zap,
		}),
	],
	exports: [LucideAngularModule],
})
export class LucideModule {}
